var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCreateJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44398",
    "data-name": "Group 44398",
    transform: "translate(-445 -397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(445 397)",
    fill: "#0c66e4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44395",
    "data-name": "Group 44395",
    transform: "translate(469 420.826)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    y2: 32,
    transform: "translate(16.013 0.174)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    y2: 32.027,
    transform: "translate(32.027 16.08) rotate(90)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCreateJob);
export default __webpack_public_path__ + "static/media/plus-create-job.76a4be28812ac3356487dd4edd0a154c.svg";
export { ForwardRef as ReactComponent };